import React, { useState, useEffect } from "react";
import "./css/Organizations.css";

const OrganizationModal = ({ isOpen, onClose, onSave, org }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    logo: "",
  });

  useEffect(() => {
    if (org) {
      setFormData({
        name: org.name || "",
        email: org.email || "",
        phone: org.phone || "",
        address: org.address || "",
        logo: org.logo || "",
      });
    } else {
      setFormData({ name: "", email: "", phone: "", address: "", logo: "" });
    }
  }, [org]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    onSave(formData);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{org ? "Edit Organization" : "Create Organization"}</h2>
          <button className="close-btn" onClick={onClose}>✖</button>
        </div>

        <div className="modal-body">
          <h4 className="section-title">Organization Info</h4>

          <div className="form-group">
            <label>Name</label>
            <input name="name" value={formData.name} onChange={handleChange} placeholder="Organization name" />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input name="email" value={formData.email} onChange={handleChange} placeholder="contact@org.com" />
          </div>
          <div className="form-group">
            <label>Phone</label>
            <input name="phone" value={formData.phone} onChange={handleChange} placeholder="+91 XXXXX XXXXX" />
          </div>
          <div className="form-group">
            <label>Address</label>
            <input name="address" value={formData.address} onChange={handleChange} placeholder="Full address" />
          </div>
          <div className="form-group">
            <label>Logo URL</label>
            <input name="logo" value={formData.logo} onChange={handleChange} placeholder="https://..." />
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn-outline-green" onClick={onClose}>Cancel</button>
          <button className="btn btn-success" onClick={handleSubmit}>
            {org ? "Update" : "Create"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrganizationModal;